export default __webpack_public_path__ + "static/media/customizationDefault.11818878.png";